import { Button } from "@vadiun/react-components";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-mui";
import { createUserFormInitialValues } from "./CreateUserFormInitialValues";
import { CreateUserFormType } from "./CreateUserFormType";
import { userFormValidation } from "./CreateUserFormValidation";

interface Props {
  onSubmit: (value: CreateUserFormType) => Promise<void>;
  initialValues?: CreateUserFormType;
}

export function CreateUserForm({
  onSubmit,
  initialValues = createUserFormInitialValues(),
}: Props) {
  return (
    <Formik<CreateUserFormType>
      initialValues={initialValues}
      validationSchema={userFormValidation}
      enableReinitialize
      onSubmit={onSubmit}
    >
      {({ isSubmitting, errors }) => (
        <Form className="grid w-full grid-cols-6 gap-6">
          <Field
            name="email"
            label="Email *"
            variant="outlined"
            className="col-span-3"
            component={TextField}
            fullWidth
          />
          <Field
            name="name"
            label="Nombre *"
            variant="outlined"
            className="col-span-3"
            component={TextField}
            fullWidth
          />

          <div className="col-span-6 flex justify-end">
            <Button
              type="submit"
              variant="contained"
              color="green"
              isLoading={isSubmitting}
              disabled={isSubmitting}
            >
              Guardar
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}
